<main>
  <div *ngIf="!enableSearch; else showSearchForm" class="container">
    <div class="row">
      <div class="col-12">
        <h3 style="color: red; text-align: center; margin-top: 20px">
          Warning: You must login to the system before searching the catalog
        </h3>
      </div>
    </div>
  </div>
  <ng-template #showSearchForm>
    <div [ngClass]="{ container: true, topic: embeddedComponent }">
      <h3 class="advHeading">
        Advanced Search
        <button class="btn btn-link" type="button" s (click)="clearAll()">Reset</button>
        <i
          *ngIf="toggleAS"
          class="fa fa-lg fa-compress"
          title="collapse Advanced Search boxes"
          style="
            font-size: 0.6em;
            float: right;
            margin-right: 2%;
            cursor: pointer;
            margin-top: 1.5%;
          "
          tabindex="0"
          (click)="collapseAS()"
          (keyup.enter)="collapseAS()"
        ></i>
        <i
          *ngIf="!toggleAS"
          class="fa fa-lg fa-expand"
          title="expand Advanced Search boxes"
          style="
            font-size: 0.6em;
            float: right;
            margin-right: 2%;
            cursor: pointer;
            margin-top: 1.5%;
          "
          tabindex="0"
          (click)="expandAS()"
          (keyup.enter)="expandAS()"
        ></i>
      </h3>
      <div *ngIf="toggleAS" class="advance-phrase">
        <!-- 1st Search Term -->
        <div class="advPhraseContainer">
          <div
            [ngClass]="{
              'advInput col-sm-11': true,
              'col-md-3': !embeddedComponent,
              'col-md-5': embeddedComponent
            }"
          >
            <input
              agAutofocus
              name="input1"
              type="text"
              role="textbox"
              [(ngModel)]="inputValue1"
              [placeholder]="embeddedComponent ? 'Search Term' : 'Enter a Search Term'"
              (change)="fetchFilters()"
              (keydown.enter)="onEnterInput()"
            />
          </div>
          <div class="advIndexOperator col-12 text-center">
            <select [(ngModel)]="queryOpt1" name="queryOption1" (change)="fetchFilters()">
              <option value="ALL">All of these words</option>
              <option value="ANY">Any of these words</option>
              <option value="phrase">This Exact Phrase</option>
            </select>
            <div class="textIn">in</div>
            <select [(ngModel)]="ind1" name="index1" (change)="fetchFilters()">
              <option
                *ngFor="let index of advancedSearchIndexes?.advancedSearchBoxOneIndexes"
                [ngValue]="index.value"
              >
                {{ index.name }}
              </option>
            </select>
            <select [(ngModel)]="matchJoinOpt1" name="matchJoinOperator1" (change)="fetchFilters()">
              <option value="AND">AND</option>
              <option value="OR">OR</option>
              <option value="NOT">NOT</option>
            </select>
          </div>
          <div class="clearfix"></div>
        </div>
        <!-- 2nd Search Term -->
        <div class="advPhraseContainer">
          <div
            [ngClass]="{
              'advInput col-sm-11': true,
              'col-md-3': !embeddedComponent,
              'col-md-5': embeddedComponent
            }"
          >
            <input
              name="input2"
              type="text"
              role="textbox"
              [(ngModel)]="inputValue2"
              [placeholder]="embeddedComponent ? 'Search Term' : 'Enter a Search Term'"
              (change)="fetchFilters()"
              (keydown.enter)="onEnterInput()"
            />
          </div>
          <div class="advIndexOperator col-12 text-center">
            <select [(ngModel)]="queryOpt2" name="queryOption2" (change)="fetchFilters()">
              <option value="ALL">All of these words</option>
              <option value="ANY">Any of these words</option>
              <option value="phrase">This Exact Phrase</option>
            </select>
            <div class="textIn">in</div>
            <select [(ngModel)]="ind2" name="index2" (change)="fetchFilters()">
              <option
                *ngFor="let index of advancedSearchIndexes?.advancedSearchBoxOneIndexes"
                [ngValue]="index.value"
              >
                {{ index.name }}
              </option>
            </select>
            <select [(ngModel)]="matchJoinOpt2" name="matchJoinOperator2" (change)="fetchFilters()">
              <option value="AND">AND</option>
              <option value="OR">OR</option>
              <option value="NOT">NOT</option>
            </select>
          </div>
          <div class="clearfix"></div>
        </div>
        <!-- 3rd Search Term -->
        <div class="advPhraseContainer">
          <div
            [ngClass]="{
              'advInput col-sm-11': true,
              'col-md-3': !embeddedComponent,
              'col-md-5': embeddedComponent
            }"
          >
            <input
              name="input3"
              type="text"
              role="textbox"
              [(ngModel)]="inputValue3"
              [placeholder]="embeddedComponent ? 'Search Term' : 'Enter a Search Term'"
              (change)="fetchFilters()"
              (keydown.enter)="onEnterInput()"
            />
          </div>
          <div class="advIndexOperator col-12 text-center">
            <select [(ngModel)]="queryOpt3" name="queryOption3" (change)="fetchFilters()">
              <option value="ALL">All of these words</option>
              <option value="ANY">Any of these words</option>
              <option value="phrase">This Exact Phrase</option>
            </select>
            <div class="textIn">in</div>
            <select [(ngModel)]="ind3" name="index3" (change)="fetchFilters()">
              <option
                *ngFor="let index of advancedSearchIndexes?.advancedSearchBoxOneIndexes"
                [ngValue]="index.value"
              >
                {{ index.name }}
              </option>
            </select>
            <select [(ngModel)]="matchJoinOpt3" name="matchJoinOperator3" (change)="fetchFilters()">
              <option value="AND">AND</option>
              <option value="OR">OR</option>
              <option value="NOT">NOT</option>
            </select>
          </div>
          <div class="clearfix"></div>
        </div>
        <!-- 3rd TERM ENDS HERE -->
        <!-- Search by Date and Sort Order -->
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <div>Sort Order -</div>
          <select name="sortOrder" [(ngModel)]="sortByValue">
            <option value="relevance">Relevance</option>
            <option value="title_asc">Title Ascending</option>
            <option value="title_desc">Title Descending</option>
            <option value="date_asc">Date Ascending</option>
            <option value="date_desc">Date Descending</option>
            <option value="author_asc">Author Ascending</option>
            <option value="author_desc">Author Descending</option>
          </select>
        </div>
      </div>

      <div *ngIf="showNoResourceMessage" class="container-fluid">
        <div class="row">
          <div><strong style="color: red">Please provide one or more valid resources!</strong></div>
        </div>
      </div>

      <!-- Choose Resources -->
      <h3 class="advHeading" *ngIf="resourceLabel">
        {{ resourceLabel }}

        <i
          *ngIf="toggleResource"
          class="fa fa-lg fa-compress"
          title="collapse resources"
          style="
            font-size: 0.6em;
            float: right;
            margin-right: 2%;
            cursor: pointer;
            margin-top: 1.5%;
          "
          tabindex="0"
          (click)="collapseResources()"
          (keyup.enter)="collapseResources()"
        ></i>
        <i
          *ngIf="!toggleResource"
          class="fa fa-lg fa-expand"
          title="expand resources"
          style="
            font-size: 0.6em;
            float: right;
            margin-right: 2%;
            cursor: pointer;
            margin-top: 1.5%;
          "
          tabindex="0"
          (click)="expandResources()"
          (keyup.enter)="expandResources()"
        ></i>
      </h3>

      <div *ngIf="toggleResource" class="container-fluid">
        <advanced-resources
          [embeddedComponent]="embeddedComponent"
          [resourcesAS]="resourcesArray"
          (fetchResEE)="setResources($event)"
        >
        </advanced-resources>
      </div>

      <!-- refine Your search -->
      <div *ngIf="availableFilters">
        <refine-search
          [availableFilters]="availableFilters"
          [embeddedComponent]="embeddedComponent"
          (filterChangeEE)="fetchFilters()"
        >
        </refine-search>
      </div>

      <div *ngIf="showSaveQueryButton" class="container-fluid">
        <div class="row">
          <div class="col-12">
            <input
              matInput
              style="border-style: solid"
              placeholder="Chip Description"
              [(ngModel)]="chipDescription"
            />
            <button class="btn btn-dark" type="button" (click)="saveChipQuery()">Save Query</button>
          </div>
        </div>
      </div>

      <!-- ADVANCED SEARCH -->
      <!-- Actions Events -->
      <div class="mob-actions one-btn">
        <button
          *ngIf="!embeddedComponent"
          type="button"
          class="d-inline d-lg-none btn btn-link"
          [disabled]="!canDoAdvancedSearch"
          [ngClass]="{ 'greyed-out': !canDoAdvancedSearch }"
          (click)="doAdvancedSearch()"
        >
          <i
            [ngClass]="fetchingFilters ? 'fa fa-spin fa-circle-o-notch' : 'fa fa-search'"
            aria-hidden="true"
            style="color: var(--button-color) !important; margin-right: 10px"
          ></i
          >Search <span *ngIf="hitsCount > -1">{{ hitsCount }} Records</span>
        </button>
        <button
          *ngIf="!embeddedComponent"
          type="button"
          class="d-none d-lg-inline-block btn btn-lg fixed shadow right-100 bottom-40 btn-primary"
          [disabled]="!canDoAdvancedSearch"
          [ngClass]="{ 'greyed-out': !canDoAdvancedSearch }"
          (click)="doAdvancedSearch()"
        >
          <i
            [ngClass]="fetchingFilters ? 'fa fa-spin fa-circle-o-notch' : 'fa fa-search'"
            aria-hidden="true"
            style="margin-right: 10px"
          ></i
          >Search
          <span *ngIf="hitsCount > -1">{{ hitsCount }} Records</span>
        </button>
      </div>
    </div>
  </ng-template>
</main>
